module.exports = __webpack_public_path__ + "img/cover.d904b28a.png";